// Adresse des Vermittlers (Cloudflare Worker).
//
// WARUM: Frueher standen die Discord-Adressen direkt hier im Quelltext und
// waren fuer jeden Besucher der Seite auslesbar. Jetzt kennt sie nur noch der
// Vermittler. Die Homepage nennt bloss ein Stichwort ("ankauf", "zoll", ...).
//
// Diese Adresse darf ruhig oeffentlich sein: Der Vermittler nimmt nur
// Anfragen an, die tatsaechlich von auto-mah.com kommen.
export const FORMULAR_URL =
  "https://automah-formular.husmohamed812.workers.dev";
